import React from 'react'
import RightSide from '../components/common/rightSide';
import ReviewProcess from '../components/other/reviewProcess';

const ReviewProcessPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    <div className='col-md-4'>
                        <RightSide />
                    </div>
                    <div className='col-md-8'>
                        <ReviewProcess />
                    </div>

                </div>
            </div>
        </>
    )
}

export default ReviewProcessPage;